import "./../assets/styles/chatButton.css";
import Image from "./Image";
import { openSupportChat } from "../utils/openSupportChat";

const ChatButton = () => {
  return (
    <button
      className="chat-trigger"
      onClick={openSupportChat}
      aria-label="Abrir chat"
    >
      <Image image="help-btn.png" webp alt="Abrir chat" className="chat-trigger__icon" />
    </button>
  );
};

export default ChatButton;
